/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

export default {
  download_import_items_example: 'تحميل القالب',
  add_row: 'إضافة سيارة أخرى'
}
